import { FormControl, FormLabel, ScaleFade, Switch, Tag } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IControlSwitch {
  isChecked: boolean;
  handleChange: () => void;
}

const ControlSwitch: React.FC<IControlSwitch> = ({ isChecked = false, handleChange }) => {
  const { t } = useTranslation(['common', 'accountBilling']);

  return (
    <div>
      <FormControl display="flex" alignItems="center">
        <FormLabel htmlFor="billing-plan" mb="0" mr="2" fontSize="xs" fontWeight="600">
          {t('accountBilling:billedMonthly')}
        </FormLabel>
        <Switch id="billing-plan" colorScheme="secondary" isChecked={isChecked} onChange={handleChange} />
        <FormLabel htmlFor="billing-plan" mb="0" ml="2" fontSize="xs" fontWeight="600">
          {t('accountBilling:billedYearly')}
        </FormLabel>
        <ScaleFade initialScale={0.8} in={isChecked}>
          <Tag colorScheme="secondary" color="secondary.500" fontSize="xs">
            {t('accountBilling:1FreeMonth')}
          </Tag>
        </ScaleFade>
      </FormControl>
    </div>
  );
};

export default ControlSwitch;
